import { render } from "./BaseFilterCategory.vue?vue&type=template&id=239e69c0"
import script from "./BaseFilterCategory.vue?vue&type=script&lang=js"
export * from "./BaseFilterCategory.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__